import { useContext } from 'react';

import { ConfirmationContext } from '@/context/ConfirmationDialogContext';
import type { ConfirmationOptions } from '@/context/ConfirmationDialogContext';

const useConfirm = (): ((options: ConfirmationOptions) => Promise<boolean>) => {
  const context = useContext(ConfirmationContext);
  if (context === undefined) {
    throw new Error('useConfirm must be used within a ConfirmationProvider');
  }
  return context.confirm;
};

export default useConfirm;
